/** @jsx jsx */
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { jsx } from '@emotion/core';
import { useMediaQuery } from '@material-ui/core';

import { ICustomTheme } from 'interfaces';
import ErrorRedirectionView from 'components/ErrorRedirectionView';
import { challengeSelector } from 'reducers/challenge.reducer';
import { ROUTES } from '../../constants';
import * as S from './styles';

interface IAccessDeniedProps {
  message?: string;
}

const AccessDenied = ({ message }: IAccessDeniedProps): JSX.Element | null => {
  const { t } = useTranslation();
  const { id: challengeIdString }: { id: string } = useParams();
  const challengeId = Number(challengeIdString);
  const { data } = useSelector(challengeSelector(challengeId));
  const isDownSm = useMediaQuery((theme: ICustomTheme) =>
    theme.breakpoints.down('sm'),
  );

  return (
    <S.Container>
      <S.Banner type={data?.type || 'Classic'} />
      <S.PageContainer>
        <ErrorRedirectionView
          errorText={message ?? t('core.access_denied')}
          actionText={t('core.go_back_home')}
          buttonText={t('menu.home')}
          redirection={ROUTES.HOME}
          isMobile={isDownSm}
        />
      </S.PageContainer>
    </S.Container>
  );
};

export default AccessDenied;
